import React from 'react';
import styles from './Footer.module.css';

export const Footer = () => {
  return (
    <>
      <footer className={styles.pagefooter}>
        <div className={styles.footercopyright}>
          © 2019 - TODOS LOS DERECHOS RESERVADOS. COOPERATIVA DE SERVICIOS
          PUBLICOS DE COLONIA CAROYA Y JESUS MARIA LTDA.
        </div>
      </footer>
    </>
  );
};

export default Footer;
